import { render, staticRenderFns } from "./OralExpressionGetVip.vue?vue&type=template&id=455f7397&scoped=true&"
import script from "./OralExpressionGetVip.vue?vue&type=script&lang=js&"
export * from "./OralExpressionGetVip.vue?vue&type=script&lang=js&"
import style0 from "./OralExpressionGetVip.vue?vue&type=style&index=0&id=455f7397&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f7397",
  null
  
)

export default component.exports